// Bestellen
// HTML:  	https://vrendle.test/res/bestellen.html
import { ServerRequest } from '@nutshell/core';

const formSelector = '#form-signup';
const $form = $(formSelector);

if ( $form.length > 0 ) {

	// Aantal selectie (stap 1)
	if ( $form.find('[name="subscription_amount"]').length > 0 ) {

		$form.find('[name="subscription_amount"]').on('change', function(){

			calculatePrices();
		});

		calculatePrices();
	}

	// Postcode veld (stap 2)
	$form.find('[name="zipcode"]').on('keyup', function() {

	    var val  = $(this).val();
	    val = val.replace(' ', '');
	    $(this).val(val.toUpperCase());

	    addressLookup();
	});

	$form.find('[name="housenumber"]').on('keyup', function() { addressLookup(); });
	$form.find('[name="housenumber_add"]').on('keyup', function() { addressLookup(); });

	$form.on('valid', function(e) {

		e.preventDefault();

		const rqst = new ServerRequest();

		rqst.submit(formSelector, 'submitSignup').then( (response) => {

			window.location.replace(response.result.redirect);
		}).catch((e) =>{
			// alert('foutmelding 2');
		});

	});
}

function calculatePrices() {

	var selectedSubscription = $form.find('[name="subscription_amount"]:checked');
	var amountSubscriptions = parseInt(selectedSubscription.val(), 10 );

	if ( !isNaN(amountSubscriptions) ) {

		var monthlyCosts = selectedSubscription.data('price-month');
		var setupCosts = selectedSubscription.data('price-setup');
		var firstMonthCosts = selectedSubscription.data('price-firstmonth');
		console.log(monthlyCosts);
		$form.find(".pricelabel-monthly").html( formatPrice(monthlyCosts) );
		// $form.find("#pricelabel-per-year").html( formatPrice(yearCostsSubscription) );
		$form.find("#pricelabel-setup").html( formatPrice(setupCosts) );
		$form.find("#pricelabel-firstmonth").html( formatPrice(firstMonthCosts) );

		var labelHeadsets = 'bril';

		if ( amountSubscriptions > 1 ) {
			labelHeadsets = 'brillen';
		}

		$form.find(".pricelabel-headsets").html( labelHeadsets );
	}
}

function formatPrice(amount) {

	amount = parseFloat(amount);
	var formatted = '0';

	if ( !isNaN(amount) ) {

		formatted = amount.toFixed(2);
		formatted = formatted.replace('.', ',');
		formatted = formatted.replace(',00', ',-');
	}

	return formatted;
}

function addressLookup() {

	var lookupDelay = null;

	var zip = $form.find('[name="zipcode"]').val();
	var nr = $form.find('[name="housenumber"]').val();
	var nrAdd = $form.find('[name="housenumber_add"]').val();

	if ( zip.length >= 6 && nr.length > 0 ) {

		clearTimeout(lookupDelay);

		lookupDelay = setTimeout(function() {

			const rqst = new ServerRequest();

			rqst.post('addressLookup', {zip, nr, nrAdd}).then( (response) => {

				$form.find('[name="street"]').val(response.result.street);
				$form.find('[name="city"]').val(response.result.city);
			}).catch( (e) => {});

		}, 300);
	}
}